<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div  @click="defaultMask" class="mask" key="1" v-if="show" @touchmove.prevent></div>

    <div class="statePop" v-show="show" key="2">
      <div class="statePop-title">
        <span class="statePop-title-name">设备信息</span>
        <el-button class="statePop-title-value" icon="el-icon-close" type="text" @click="close"></el-button>
      </div>
      <div class="statePop-main">
        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">设备ID</span>
          </div>
          <div class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{deviceAddr}}</span>
          </div>
        </div>
        <div class="statePop-main-line"></div>

        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">设备类型</span>
          </div>
          <div class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{deviceType}}</span>
          </div>
        </div>
        <div class="statePop-main-line"></div>

        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">设备状态</span>
          </div>
          <div class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{status}}</span>
          </div>
        </div>
        <div class="statePop-main-line"></div>

        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">更新时间</span>
          </div>
          <div  class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{statusTime}}</span>
          </div>
        </div>
        <div class="statePop-main-line"></div>

        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">离线阈值</span>
          </div>
          <div class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{threshold}}小时</span>
          </div>
        </div>
        <div class="statePop-main-line"></div>

        <div class="statePop-main-item">
          <div class="statePop-item-name">
            <span class="statePop-item-nameOpt">上传周期</span>
          </div>
          <div class="statePop-item-value">
            <span class="statePop-item-valueOpt">{{uploadCycle}}分钟</span>
          </div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
  export default {
    name: 'stateInfo',
    data() {
      return {
        deviceAddr: '',
        deviceType: '',
        show: false,
        status: '',
        statusTime: '',
        threshold: 0,
        uploadCycle: 0,
      }
    },
    created() {
    },
    mounted() {
      this.getStateInfo(); //获取设备状态
    },

    methods: {
      /**
       * 获取设备状态
       */
      getStateInfo() {
        let that = this;
        this.$SporePestCommon.getDeviceState(this.deviceAddr, function (response) {
          console.log("1111111111", response)
          //0001-01-01T00:00:00Z
          that.status = response.status == 0 ? '离线' : '在线'; //设备状态
          that.statusTime= that.timeSplit(response.statusTime); //状态更新时间
          that.threshold = response.threshold; //在离线阈值
          that.uploadCycle = response.uploadCycle; //上传洲际
        })
      },

      /**
       * 转换状态更新时间
       * @param time
       * @returns {string}
       */
      timeSplit(time) {
        return time.substring(0, 10) + " " + time.substring(11, 19)
      },

      /**
       * 点击取消关闭画面
       */
      close() {
        this.show = false;
      },

      /**
       * 点击其他空余部分关闭画面
       */
      defaultMask() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  // 全局弹窗
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
  }

  .statePop {
    height: 40%;
    width: 25%;
    background: #2B5DA0;
    border-radius: 8px;
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -10%;
    z-index: 20;

    .statePop-title {
      width: 100%;
      height: 15%;
      display: table;
      color: #ffffff;
      font-size: 26px;
      font-family: SimSun;
      font-weight: bold;

      .statePop-title-name {
        display: table-cell;
        vertical-align: middle;
        padding-left: 40%
      }
      .statePop-title-value {
        float: right;
        padding: 3px 3px;
        color: cyan;
        font-size: 20px;
      }
    }

    .statePop-main {
      width: 100%;
      height: 85%;
      color: #ffffff;
      font-size: 24px;
      font-family: SimSun;

      .statePop-main-item {
        width: 100%;
        height: 16.5%;
        display: flex;
        flex-direction: row;

        .statePop-item-name {
          width: 40%;
          height: 100%;
          display: table;

          .statePop-item-nameOpt {
            display: table-cell;
            vertical-align: middle;
            text-align: center
          }
        }

        .statePop-item-value {
          width: 60%;
          height: 100%;
          display: table;

          .statePop-item-valueOpt {
            display: table-cell;
            vertical-align: middle;
            text-align: center
          }
        }
      }

      .statePop-main-line {
        width: 96%;
        height: 0.1%;
        margin-left: 2%;
        background-color: #00CFCF
      }
    }

    .el-card {
      background-color:transparent;
      border: none;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      border: 1px solid #4CD7E3;
      color: #ffffff;
      width: 60%;
    }

    /deep/ .el-input__icon{
      font-size:24px;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/stateInfo.vue